import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/system/usersorgsauthority',
    name: 'POST_USER_ORG_AUTHORITY',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
